import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { RoutePath } from '@/routes'
import { apiInstance } from '@/apiInstance'

export default function HomePage() {
  const navigate = useNavigate()

  useEffect(() => {
    const isAuthenticated = Boolean(localStorage.getItem('authToken') || apiInstance.authToken)
    if (!isAuthenticated) {
      navigate(RoutePath.LOGIN, { replace: true })
    } else {
      navigate(RoutePath.DEMOS, { replace: true })
    }
  }, [navigate])

  return (
    <div className="container">
      <div>Loading...</div>
    </div>
  )
}
